import { FunctionComponent, Fragment } from 'react'
import ZendeskComponent from 'react-zendesk'

import { useZendesk } from './useZendesk'

const Zendesk: FunctionComponent = () => {
  const { ZENDESK_SETTINGS, zendeskKey, onZendeskLoaded } = useZendesk()

  return (
    <Fragment>
      <ZendeskComponent
        defer
        zendeskKey={zendeskKey}
        {...ZENDESK_SETTINGS}
        onLoaded={onZendeskLoaded}
      />
    </Fragment>
  )
}

export { Zendesk }
